import { Box, Button, Flex, Text } from '@chakra-ui/react'
import BlackCartIcon from '@components/icons/black-cart-icon'
import { useCart } from '@contexts/cart/cart.context'
import { useStore } from '@contexts/store'
import React from 'react'

const SereneCartButton = () => {
  const { openDrawer, setDrawerView } = useStore()
  const { totalItems } = useCart()
  function handleCartOpen() {
    setDrawerView('CART_SIDEBAR')
    return openDrawer()
  }

  return (
    <Box as="button" height="full" onClick={handleCartOpen} maxW="min-content">
      <Box position="relative">
        <BlackCartIcon />
        <Flex
          position="absolute"
          left="0"
          right="0"
          top="30%"
          justify="center"
          h="min-content"
          textAlign="center"
        >
          <Text as="span" color="white" fontSize="10px">
            {totalItems}
          </Text>
        </Flex>
      </Box>
    </Box>
  )
}

export default SereneCartButton
